document.addEventListener("DOMContentLoaded", function () {
  const articleContent = document.querySelector(".xo-main-article__content");

  if (!articleContent) return;

  const headings = articleContent.querySelectorAll("h2");

  if (!headings.length) return;

  const toc = document.createElement("nav");
  toc.className = "xo-unize-toc";
  toc.setAttribute("aria-label", "Table of contents");

  const tocTitle = document.createElement("p");
  tocTitle.className = "xo-unize-toc__title";
  tocTitle.textContent = "目次";

  const tocList = document.createElement("ol");
  tocList.className = "xo-unize-toc__list";

  headings.forEach((heading, index) => {
    const id = "toc-heading-" + (index + 1);
    heading.id = id;

    const item = document.createElement("li");
    item.className = "xo-unize-toc__item";

    const link = document.createElement("a");
    link.className = "xo-unize-toc__link";
    link.href = "#" + id;

    const num = document.createElement("span");
    num.className = "xo-unize-toc__num";
    num.textContent = String(index + 1).padStart(2, "0");

    const text = document.createElement("span");
    text.className = "xo-unize-toc__text";
    text.textContent = heading.textContent.trim();

    link.appendChild(num);
    link.appendChild(text);
    item.appendChild(link);
    tocList.appendChild(item);
  });

  toc.appendChild(tocTitle);
  toc.appendChild(tocList);

  const firstHeading = headings[0];
  articleContent.insertBefore(toc, firstHeading);
});